import React, { useState } from 'react';
import { Modal, Button, Tab, Nav, Row, Col, Badge } from 'react-bootstrap';

const ProfileDetailModal = ({ show, profile, onHide }) => {
  const [activeTab, setActiveTab] = useState('info');

  if (!profile) return null;

  const formatDate = dateString => {
    return dateString ? new Date(dateString).toLocaleString() : 'Never';
  };

  const renderStatusBadge = status => {
    const variant = status === 'COMPLETED' ? 'success' : 'warning';
    return (
      <Badge bg={variant} className="text-capitalize">
        {status.toLowerCase().replace('_', ' ')}
      </Badge>
    );
  };

  const renderInfoTab = () => (
    <div className="p-3">
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Profile ID
        </Col>
        <Col sm={8}>{profile.id}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Created At
        </Col>
        <Col sm={8}>{formatDate(profile.createdAt)}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Modified At
        </Col>
        <Col sm={8}>{formatDate(profile.modifiedAt)}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Wallet ID
        </Col>
        <Col sm={8}>{profile.walletId}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Primary Wallet ID
        </Col>
        <Col sm={8}>{profile.primaryWalletId}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Profile Type
        </Col>
        <Col sm={8}>{profile.isPrimary ? 'Primary Profile' : 'Secondary Profile'}</Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} className="text-muted">
          Status
        </Col>
        <Col sm={8}>{renderStatusBadge(profile.status)}</Col>
      </Row>
      {profile.status !== 'COMPLETED' && profile.reasonsSummary && (
        <Row className="mb-3">
          <Col sm={4} className="text-muted">
            Decline Reason
          </Col>
          <Col sm={8}>{profile.reasonsSummary}</Col>
        </Row>
      )}
      {profile.code && (
        <Row className="mb-3">
          <Col sm={4} className="text-muted">
            Code
          </Col>
          <Col sm={8}>{profile.code}</Col>
        </Row>
      )}
      {profile.checkInRefId && (
        <Row className="mb-3">
          <Col sm={4} className="text-muted">
            Check-in Reference
          </Col>
          <Col sm={8}>{profile.checkInRefId}</Col>
        </Row>
      )}
      {profile.status !== 'COMPLETED' && profile.importantReason && (
        <Row className="mb-3">
          <Col sm={4} className="text-muted">
            Important Note
          </Col>
          <Col sm={8}>{profile.importantReason}</Col>
        </Row>
      )}
    </div>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" aria-labelledby="profile-detail-modal">
      <Modal.Header closeButton>
        <Modal.Title id="profile-detail-modal">Profile Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <Tab.Container activeKey={activeTab} onSelect={k => setActiveTab(k)}>
          <Nav variant="tabs" className="px-3 pt-3">
            <Nav.Item>
              <Nav.Link eventKey="info">Info</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="info">{renderInfoTab()}</Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="danger" className="me-auto">
          <i className="fa fa-trash"></i>
          Delete Profile
        </Button> */}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        {/* <Button variant="primary">
          <i className="fa fa-edit"></i>
          Edit Profile
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileDetailModal;
